module.exports = __webpack_public_path__ + "static/media/yuntaishan2.96401902.jpg";